export const onlyDigits = (value: string): string => value.replace(/\D/g, "");

export const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const formatDateToLong = (date: string): string => {
  const dateObj = new Date(date);
  const dateString = dateObj.toLocaleDateString("fr-FR", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

  return dateString.replace(/^[1] /, "1er ");
};

export const formatDateAndTimeToLong = (date: string): string => {
  const dateObj = new Date(date);
  const dateString = dateObj.toLocaleDateString("fr-FR", {
    day: "numeric",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

  return dateString.replace(/^[1] /, "1er ");
};

export const formatFrenchPhone = (phone: string): string => {
  const digits = phone.replace(/\D/g, "");
  if (digits.length !== 10) return phone.trim();
  return digits.replace(/(\d{2})(?=\d)/g, "$1 ");
};

export const getStringDateFromMonthsAgo = (monthsAgo: number): string => {
  const today = new Date();
  const dateFromMonthsAgo = new Date(today);
  dateFromMonthsAgo.setMonth(dateFromMonthsAgo.getMonth() - monthsAgo);

  const year = dateFromMonthsAgo.getFullYear();
  const month = String(dateFromMonthsAgo.getMonth() + 1).padStart(2, "0");
  const day = String(dateFromMonthsAgo.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};
